import type { LeaseActionProps } from '../../../models/Types';
import RequestSignatureModal from '../../RequestSignatureModal';

export default function OpenModalRequestSignature(props: LeaseActionProps) {
  return (
    <RequestSignatureModal
      onClose={props.terminateActiveAction}
      lease={props.lease}
      property={props.property}
      history={props.history}
    />
  );
}
